import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

let confirmId = 0;
/** options: confirmText/cancelText — подписи кнопок, title — заголовок, icon — значок над заголовком. */
export function openConfirm(message, options = {}) {
  return new Promise((resolve) => {
    const id = ++confirmId;
    window.dispatchEvent(new CustomEvent('app-confirm', { detail: { id, message, resolve, confirmText: options.confirmText, cancelText: options.cancelText, title: options.title, icon: options.icon } }));
  });
}

export default function Confirm() {
  const { t } = useTranslation();
  const [state, setState] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      const { id, message, resolve, confirmText, cancelText, title, icon } = e.detail;
      setState({ id, message, resolve, confirmText, cancelText, title, icon });
    };
    window.addEventListener('app-confirm', handler);
    return () => window.removeEventListener('app-confirm', handler);
  }, []);

  if (!state) return null;

  const { message, resolve, confirmText, cancelText, title, icon } = state;

  const close = (answer) => {
    try { resolve(!!answer); } catch (err) { /* noop */ }
    setState(null);
  };

  return (
    <div className="confirm-overlay">
      <div className="confirm-modal">
        {icon && <div className="confirm-icon">{icon}</div>}
        {title && <div className="confirm-title">{title}</div>}
        <div className={`confirm-message ${title ? 'with-title' : ''}`}>{message}</div>
        <div className="confirm-actions">
          <button className="btn-cancel" onClick={() => close(false)}>{cancelText || t('common.cancel')}</button>
          <button className="btn-save" onClick={() => close(true)}>{confirmText || t('common.delete')}</button>
        </div>
      </div>
    </div>
  );
}
